import { useSelector } from 'react-redux';
import { Transaction } from '../../models';
import { selectTransactionsList } from '../../selectors';

export const useTransactionsList = (): Transaction[] | null => {
  const transactions = useSelector(selectTransactionsList);

  return transactions;
};
